import React, { useContext, useEffect, useRef } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { UserContext } from '../contexts/UserContext';

// Prueba con 1 minuto (60 * 1000).
// Cuando confirmes que funciona, cámbialo a 15 minutos: 15 * 60 * 1000
const INACTIVITY_LIMIT = 30 * 60 * 1000;

export default function PrivateRoute({ children }) {
  const { user, setUser } = useContext(UserContext);
  const navigate = useNavigate();

  const lastActivityRef = useRef(Date.now());
  const lastMousePosRef = useRef({ x: 0, y: 0 });
  const isLoggingOutRef = useRef(false);

  useEffect(() => {
    if (!user) return;

    lastActivityRef.current = Date.now();
    isLoggingOutRef.current = false;

    const cerrarSesion = () => {
      if (isLoggingOutRef.current) return;
      isLoggingOutRef.current = true;

      localStorage.removeItem('user');
      setUser(null);
      alert('Su sesión ha expirado por inactividad. Por favor, inicie sesión nuevamente.');
      navigate('/', { replace: true });
    };

    const verificarTiempo = () => {
      const tiempoInactivo = Date.now() - lastActivityRef.current;
      const segundos = Math.floor(tiempoInactivo / 1000);

      // Muestra el conteo en la consola (F12) para verificar en tiempo real
      console.log(`[GSAN Inactividad] ${segundos}s / ${INACTIVITY_LIMIT / 1000}s`);

      if (tiempoInactivo >= INACTIVITY_LIMIT) {
        cerrarSesion();
      }
    };

    const detectarActividad = (e) => {
      if (e.type === 'mousemove') {
        const dx = Math.abs(e.clientX - lastMousePosRef.current.x);
        const dy = Math.abs(e.clientY - lastMousePosRef.current.y);
        // Ignorar si el cursor se movió menos de 5 píxeles (evita falsos reinicios)
        if (dx < 5 && dy < 5) return;
        lastMousePosRef.current = { x: e.clientX, y: e.clientY };
      }

      lastActivityRef.current = Date.now();
    };

    // Si la pestaña estaba en segundo plano, verificar de inmediato al volver
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        verificarTiempo();
      }
    };

    const intervalId = setInterval(verificarTiempo, 1000);

    const eventos = [
      'mousemove',
      'mousedown',
      'keydown',
      'scroll',
      'touchstart',
      'click'
    ];

    eventos.forEach((evento) => {
      window.addEventListener(evento, detectarActividad, { passive: true });
    });
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      clearInterval(intervalId);
      eventos.forEach((evento) => {
        window.removeEventListener(evento, detectarActividad);
      });
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [user, setUser, navigate]);

  if (!user) return <Navigate to="/" replace />;

  return children;
}